import { Link } from 'react-router-dom';
import type { AdminCallOwnerResolution } from '@oracord/shared';

export function OwnerResolutionLabel({ owner }: { owner: AdminCallOwnerResolution | null }) {
  if (!owner) return <span className="text-xs font-medium text-amber-600">Unassigned</span>;
  const label = owner.staffProfile?.displayName || owner.staffName || owner.staffProfile?.staffIdentity || owner.staffIdentity;
  const suffix = owner.staffProfile || !owner.staffName ? null : owner.staffIdentity;
  const content = (
    <span className="inline-flex flex-col text-xs leading-tight">
      <span className="font-medium text-slate-700">{label}</span>
      {suffix && <span className="text-slate-500">{suffix}</span>}
    </span>
  );
  if (!owner.staffProfileId) return content;
  return (
    <Link
      to={`/members?staffProfileId=${encodeURIComponent(owner.staffProfileId)}`}
      className="hover:underline"
      title="View linked Team profile"
    >
      {content}
    </Link>
  );
}
